import { initTelemetry } from './telemetry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './common.css';
import './vendor.min.css';
import './index.css';
/* The storefront token bridge — the --ink / --mut / --ln / --o names every
   ported reference page reads. Loaded globally so a page only has to carry the
   `sfx` class. See src/shared/styles/storefront-tokens.css. */
import './shared/styles/storefront-tokens.css';
import { startVersionUpdateListener } from './code';

if (process.env.NODE_ENV === 'development') {
  const OVERLAY_ID = 'webpack-dev-server-client-overlay';
  const removeOverlay = () => document.getElementById(OVERLAY_ID)?.remove();
  new MutationObserver(removeOverlay).observe(document.body, { childList: true });
  removeOverlay();
}

initTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
// startVersionUpdateListener(); 
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Send content height to parent when embedded in an iframe
if (window.self !== window.top) {
  const sendHeight = () => {
    const height = document.body.offsetHeight;
    window.parent.postMessage({ type: 'IFRAME_HEIGHT', height }, '*');
  };
  const observer = new ResizeObserver(sendHeight);
  observer.observe(document.body);
}
